import { MaintenaceWorkflowData } from "@/features/privateCompanies/types/maintenance/workflows/maintenanceWorkflows.type";
import { createContext, useContext } from "react";
import { MaintenanceForwardingDirectiveEntryMap } from "../../features/forwardings/types/forwardings/directiveEntries/directiveEntry.type";
import { MaintenanceForwardingData } from "../../features/forwardings/types/maintenanceForwarding.type";
import { MaintenanceForwardingsDirectiveEntryKlass } from "../../features/forwardings/types/maintenanceForwardingsDirectiveEntryKlasses.type";
import { MaintenanceForwardingEstablishmentChoiceEntryKlass, MaintenanceForwardingEstablishmentChoiceEntryMap } from "../../features/forwardings/types/forwardings/establishmentChoiceEntries/establishmentChoiceEntry.type";

export const ForwardingTabContext = createContext<{
  workflow: MaintenaceWorkflowData | undefined;
  forwarding: MaintenanceForwardingData<
    MaintenanceForwardingDirectiveEntryMap[MaintenanceForwardingsDirectiveEntryKlass],
    MaintenanceForwardingEstablishmentChoiceEntryMap[MaintenanceForwardingEstablishmentChoiceEntryKlass]
  > | undefined;
  forwardingUpdatedAt: number;
  directiveEntryKlass: MaintenanceForwardingsDirectiveEntryKlass | undefined;
}>({
  workflow: undefined,
  forwarding: undefined,
  forwardingUpdatedAt: 0,
  directiveEntryKlass: undefined,
});

export const useForwardingTabContext = <
  DirectiveEntry extends MaintenanceForwardingsDirectiveEntryKlass,
  EstablishmentChoiceEntry extends MaintenanceForwardingEstablishmentChoiceEntryKlass = never,
>() => useContext(ForwardingTabContext) as {
  workflow: MaintenaceWorkflowData | undefined;
  forwarding: MaintenanceForwardingData<
    MaintenanceForwardingDirectiveEntryMap[DirectiveEntry],
    MaintenanceForwardingEstablishmentChoiceEntryMap[EstablishmentChoiceEntry]
  >;
  forwardingUpdatedAt: number;
  directiveEntryKlass: DirectiveEntry;
};
